import React from 'react';
import { Link } from 'react-router-dom';
import * as CookieConsent from 'vanilla-cookieconsent';

function Footer({ logo }) {
  return (
    <footer className="bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-8 py-16 md:px-16 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 md:gap-8 mb-12 text-center md:text-left">
          {/* Logo & Tagline */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="inline-flex md:flex items-center mb-4">
              <img src={logo || "/logo.svg"} className="h-7 w-7" alt="Veydra" />
              <span className="ml-2 text-xl font-medium text-gray-900 tracking-tight">Veydra</span>
            </Link>
            <p className="text-sm text-gray-500 leading-relaxed md:pr-4">
              Veydra is the AI-native decision engine that bridges the gap between raw data and ROI. We create living digital twins of your operations to simulate second-order effects and orchestrate change with precision.
            </p>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">Resources</h4>
            <ul className="space-y-3">
              <li><Link to="/solutions" className="text-sm text-gray-600 hover:text-gray-900">Solutions</Link></li>
              <li><a href="https://docs.veydra.io" className="text-sm text-gray-600 hover:text-gray-900">Documentation</a></li>
              <li><Link to="/innovation" className="text-sm text-gray-600 hover:text-gray-900">Innovation</Link></li>
              <li><Link to="/manifesto" className="text-sm text-gray-600 hover:text-gray-900">Manifesto</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">Company</h4>
            <ul className="space-y-3">
              <li><Link to="/contact" className="text-sm text-gray-600 hover:text-gray-900">Contact</Link></li>
              <li><Link to="/news" className="text-sm text-gray-600 hover:text-gray-900">News & Events</Link></li>
              <li><Link to="/careers" className="text-sm text-gray-600 hover:text-gray-900">Careers</Link></li>
              <li><Link to="/stay-in-touch" className="text-sm text-gray-600 hover:text-gray-900">Stay in Touch</Link></li>
            </ul>
          </div>

          {/* Get Started */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-4">Get Started</h4>
            <ul className="space-y-3">
              <li><a href="/book-demo" className="text-sm text-gray-600 hover:text-gray-900">Schedule a conversation</a></li>
              <li><Link to="/educators" className="text-sm text-gray-600 hover:text-gray-900">For Educators</Link></li>
              <li><Link to="/request-access" className="text-sm text-gray-600 hover:text-gray-900">Request access</Link></li>
              <li><a href="https://app.veydra.io" className="text-sm text-gray-600 hover:text-gray-900">Sign in</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">© 2026 Veydra. All rights reserved.</p>
          <div className="flex items-center space-x-6">
            <Link to="/privacy" className="text-sm text-gray-500 hover:text-gray-700">Privacy</Link>
            <a href="https://app.veydra.io/terms" className="text-sm text-gray-500 hover:text-gray-700">Terms</a>
            <button
              onClick={() => CookieConsent.showPreferences()}
              className="text-sm text-gray-500 hover:text-gray-700 cursor-pointer"
              type="button"
            >
              Manage Cookies
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
